const BtnSpinner = () => {
  return (
    <div className="border-purple-normal h-3 w-3 animate-spin rounded-full border-2 border-t-transparent"></div>
  );
};

export default BtnSpinner;
